<template>
  <div v-if="footerMenuLinks" class="footer-navigation-right">
    <VuepalLink
      v-for="(link, index) in footerMenuLinks"
      :key="index"
      :to="link.href"
      class="is-block has-text-weight-semibold has-text-primary is-size-normal mb-5"
    >
      {{ link.label }}
    </VuepalLink>
  </div>
</template>

<script setup lang="ts">
const { footerMenuLinks } = useInitData()
</script>

<style scoped lang="scss">
.footer-navigation-right {
  column-count: 2;
  column-gap: 30px;

  a:nth-child(4n) {
    margin-bottom: 0 !important;
  }
}
</style>
